<template>
  <div class="banner-top-skeleton-root"></div>
</template>

<style lang="scss" scoped>
.banner-top-skeleton {
  &-root {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(
      90deg,
      var(--lowcode-status-02) 25%,
      var(--lowcode-status-03) 37%,
      var(--lowcode-status-02) 63%
    );
    background-size: 400% 100%;
    border-radius: 4px;
    will-change: background-position;
    animation: skeleton-loading 1.4s ease infinite;
    z-index: 2;
  }
}
</style>
